/**
 * Puna personale — detyrat e mia, onboarding-u im, dokumentet e mia.
 *
 * Asnjë identifikues pronësie nuk dërgohet nga këtu: «i imi» e vendos serveri
 * nga token-i. Po ta dërgonte faqja, ai do të ishte dosja e dikujt tjetër, e
 * hapur me një parametër.
 */
import { authFetch } from './apiServices';
import { getAuthHeaders } from './authSession';

const API_URL = process.env.REACT_APP_API_URL || '';

function qs(params = {}) {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '' || v === 'all') continue;
    sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

async function get(path) {
  try {
    const r = await authFetch(path).then((x) => x.json());
    return r?.success ? r.data : { error: r?.error || 'Kërkesa dështoi.' };
  } catch (_) {
    return { error: 'Lidhja me serverin dështoi.' };
  }
}

async function send(path, method, body) {
  try {
    const r = await authFetch(path, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    }).then((x) => x.json());
    return r?.success ? r.data : { error: r?.error || 'Veprimi dështoi.' };
  } catch (_) {
    return { error: 'Lidhja me serverin dështoi.' };
  }
}

export default function myWorkService() {
  return {
    tasks(params = {}) { return get(`/api/my-tasks${qs(params)}`); },
    counters() { return get('/api/my-tasks/counters'); },
    onboarding() { return get('/api/my-onboarding'); },

    /** Konfirmim ose kërkesë korrigjimi — asgjë nuk shkruhet te Stafi nga këtu. */
    confirmData(action, proposed, note) {
      return send('/api/my-onboarding/confirm-data', 'POST', { action, proposed, note });
    },

    /**
     * Ngarkimi shkon me `multipart`, ndaj nuk kalon nga `authFetch` me JSON.
     * Detyra dërgohet; procesi zgjidhet nga serveri — pikërisht që të mos
     * mund të ndryshohet me dorë.
     */
    async uploadDocument(taskId, documentType, file) {
      try {
        const fd = new FormData();
        fd.append('taskId', String(taskId));
        fd.append('documentType', documentType || 'other');
        fd.append('document', file, file.name);
        const res = await fetch(`${API_URL}/api/my-onboarding/documents`, {
          method: 'POST', headers: getAuthHeaders(), body: fd,
        });
        const r = await res.json();
        return r?.success ? r.data : { error: r?.error || 'Ngarkimi dështoi.' };
      } catch (_) {
        return { error: 'Ngarkimi dështoi.' };
      }
    },

    documentsOf(onboardingId) { return get(`/api/onboarding/${onboardingId}/documents`); },
    reviewDocument(id, decision, reason) {
      return send(`/api/onboarding-documents/${id}/review`, 'POST', { decision, reason });
    },

    /** Shkarkimi kalon me header-in e autorizimit; linku i thjeshtë s'e bart. */
    async downloadDocument(id, name) {
      try {
        const res = await fetch(`${API_URL}/api/onboarding-documents/${id}/file`, { headers: getAuthHeaders() });
        if (!res.ok) return { error: 'Shkarkimi dështoi.' };
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = name || 'dokument'; a.click();
        URL.revokeObjectURL(url);
        return { ok: true };
      } catch (_) {
        return { error: 'Shkarkimi dështoi.' };
      }
    },
  };
}

export const DOCUMENT_TYPES = [
  { code: 'identity_document', label: 'Dokument identiteti' },
  { code: 'bank_document',     label: 'Konfirmim bankar' },
  { code: 'certificate',       label: 'Certifikatë' },
  { code: 'signed_contract',   label: 'Kontratë e nënshkruar' },
  { code: 'other',             label: 'Tjetër' },
];

export const DOCUMENT_STATUS = {
  pending:  { label: 'Pret shqyrtim', color: 'warning' },
  accepted: { label: 'E pranuar',     color: 'success' },
  rejected: { label: 'E refuzuar',    color: 'error' },
  replaced: { label: 'E zëvendësuar', color: 'default' },
};

export const documentTypeLabel = (c) => (DOCUMENT_TYPES.find((x) => x.code === c) || {}).label || 'Tjetër';
export const documentStatusMeta = (c) => DOCUMENT_STATUS[c] || DOCUMENT_STATUS.pending;
